import type { LayersList } from "@deck.gl/core";

import { DeckOverlayType, DeckSlot, SLOT_ORDER, SLOT_OVERLAY } from "./DeckSlot";

export interface DeckLayerRegistry {
  getLayers(overlay: DeckOverlayType): LayersList;
  removeLayers(slot: DeckSlot, key: symbol): void;
  setLayers(slot: DeckSlot, key: symbol, layers: LayersList): void;
  takeChangedOverlays(): DeckOverlayType[];
}

const createDeckLayerRegistry = (): DeckLayerRegistry => {
  // Map keeps first-insertion order when a key is updated
  const slots = new Map<DeckSlot, Map<symbol, LayersList>>();
  const changed = new Set<DeckOverlayType>();

  return {
    getLayers: (overlay) =>
      SLOT_ORDER.filter((slot) => SLOT_OVERLAY[slot] === overlay)
        .flatMap((slot) => [...(slots.get(slot)?.values() ?? [])])
        .flat(),
    removeLayers: (slot, key) => {
      if (slots.get(slot)?.delete(key)) {
        changed.add(SLOT_OVERLAY[slot]);
      }
    },
    setLayers: (slot, key, layers) => {
      const entries = slots.get(slot) ?? new Map<symbol, LayersList>();
      entries.set(key, layers);
      slots.set(slot, entries);
      changed.add(SLOT_OVERLAY[slot]);
    },
    takeChangedOverlays: () => {
      const result = [...changed];
      changed.clear();
      return result;
    },
  };
};

export default createDeckLayerRegistry;
